import * as actionTypes from './../actions/helpAction';

const initialState = {
  data: [],
  pending: true,
  error: null,
  ready: false,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.DEFAULT:
      return {
        ...state,
        ready: true,
        open: false,
      };
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        ready: true,
        data: action.data,
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    case actionTypes.OPEN_MODAL_WITH_CONTENT:
      return {
        ...state,
        key: action.key,
        open: action.open,
        content: state.data.helpItems[action.key],
      };
    case actionTypes.CLOSE_MODAL:
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
};

export default reducer;
